import { executeRequest, Request } from '@jfs/network'
// import { appAuthVerifyRequestBody } from '../data/request/body'
import { getEncryptedAuthCodeAndCodeVerifier, getEncryptedPwdAndKey, pkceCodeChallenge } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const appAuthGenerateRequestBody = (codeVerifier: string) => {
  const challenge = pkceCodeChallenge(codeVerifier)
  const encCodeChallenge = getEncryptedPwdAndKey(challenge.toString())
  return {
    application: {
      clientId: window?._env_?.REACT_APP_CLIENT_ID,
    },
    authenticateList: [
      {
        mode: 24,
        action: 'GENERATE',
        value: encCodeChallenge?.password ?? '',
      },
    ],
    purpose: 2,
    scope: 'REQUEST',
    secure: {
      encryptionKey: encCodeChallenge?.key ?? '',
      method: 'SHA-256',
    },
  }
}

const appAuthGenerate = (codeVerifier: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.appAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: appAuthGenerateRequestBody(codeVerifier),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export const appAuthVerifyRequestBody = (authCode: string, codeVerifier: string) => {
  const encryptedObj = getEncryptedAuthCodeAndCodeVerifier(authCode, codeVerifier)
  return {
    application: {
      clientId: window?._env_?.REACT_APP_CLIENT_ID,
    },
    authenticateList: [
      {
        mode: 24,
        action: 'VERIFY',
        authorizationCode: encryptedObj?.authCodeEnc ?? '',
        value: encryptedObj?.codeVerifierEnc ?? '',
      },
    ],
    purpose: 2,
    scope: 'SESSION',
    secure: {
      encryptionKey: encryptedObj?.key ?? '',
    },
  }
}

const appAuthVerify = (authCode: string, codeVerifier: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.appAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: appAuthVerifyRequestBody(authCode, codeVerifier),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { appAuthGenerate, appAuthVerify }
